import axios from 'axios';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface ICD10CodeT {
  code: string;
  description: string;
}

export interface SearchICD10RequestT {
  query: string;
  mode: 'fulltextsearch' | 'embedding';
  topK: number;
}

export interface SearchICD10ResponseT {
  codes: ICD10CodeT[];
}

export async function fetchSearchICD10(
  request: SearchICD10RequestT,
  signal?: AbortSignal
): Promise<SearchICD10ResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<SearchICD10ResponseT>(
    '/greenfield/care/labs/icd10/search',
    { query: request.query, mode: request.mode, top_k: request.topK },
    config
  );
  return response.data;
}

export interface ResolveICD10ResponseT {
  codes: ICD10CodeT[];
}

/**
 * Resolve ICD-10 codes to their authoritative descriptions. Used to hydrate a
 * code (e.g. one carried by a proposed action) into a full ``ICD10CodeT``.
 */
export async function fetchResolveICD10(
  codes: string[],
  signal?: AbortSignal
): Promise<ResolveICD10ResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<ResolveICD10ResponseT>(
    '/greenfield/care/labs/icd10/resolve',
    { codes },
    config
  );
  return response.data;
}
